import * as React from 'react';

// Bookings product tile — calendar mark on the Zezamii Bookings blue.
// Mirrors the other product app logos (LogoRoomsApp/LogoLockerApp): square tile,
// scalable via width/height props.
const LogoBookingsApp = (props) => (
	<svg xmlns='http://www.w3.org/2000/svg' width={40} height={40} viewBox='0 0 512 512' fill='none' {...props}>
		<rect width={512} height={512} rx={112} fill='#001F97' />
		<rect x={170} y={120} width={24} height={60} rx={12} fill='#FFFFFF' />
		<rect x={318} y={120} width={24} height={60} rx={12} fill='#FFFFFF' />
		<rect x={112} y={152} width={288} height={256} rx={30} fill='#FFFFFF' />
		<rect x={112} y={206} width={288} height={14} fill='#001F97' />
		<circle cx={190} cy={288} r={15} fill='#001F97' />
		<circle cx={256} cy={288} r={15} fill='#001F97' />
		<circle cx={322} cy={288} r={15} fill='#001F97' />
		<circle cx={190} cy={348} r={15} fill='#001F97' />
		<circle cx={256} cy={348} r={15} fill='#001F97' />
		<circle cx={322} cy={348} r={15} fill='#001F97' />
	</svg>
);
export default LogoBookingsApp;
